module.exports = __webpack_public_path__ + "img/logo.06df1245.svg";